import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "black-input-wrapper"
};
const _hoisted_2 = {
  key: 0,
  class: "word-stat"
};
import { ref, watch } from "vue";
export default {
  __name: 'BlackInput',
  props: {
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "input"
    },
    rows: {
      type: Number,
      default: 5
    },
    maxlength: {
      type: Number,
      default: 1024
    }
  },
  emits: ["update:value"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    watch(() => props.value, newValue => {
      model.value = newValue;
    });
    const model = ref(props.value);
    // eslint-disable-next-line no-undef
    const emits = __emit;
    const onInput = value => {
      emits("update:value", value);
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_input, {
        modelValue: model.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => model.value = $event),
        type: __props.type,
        rows: __props.rows,
        onInput: onInput,
        resize: "none",
        placeholder: __props.placeholder,
        maxlength: __props.maxlength
      }, null, 8, ["modelValue", "type", "rows", "placeholder", "maxlength"]), __props.rows > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("span", null, _toDisplayString(__props.value.length), 1), _cache[1] || (_cache[1] = _createTextVNode("/")), _createElementVNode("span", null, _toDisplayString(__props.maxlength), 1)])) : _createCommentVNode("", true)]);
    };
  }
};